// used to mock external api calls for cypress / mirage
export const passthroughs = [
  'https://get.geojs.io/v1/ip/geo.json',
  'https://api.mapbox.com/**',
  'https://events.mapbox.com/**'
]
